/**
 * Receives fieldConfig and list of keywords and returns filtered keywords
 * based on `apply-dropdown-filter` and `allowable-dropdown`
 * If `apply-dropdown-filter` is false, returns keywords as it is
 * @param {*} fieldConfig
 * @param {*} keywords
 */
const keywordFilterBlock = (fieldConfig, keywords) => {
	let result = [...keywords];
	if (fieldConfig["apply-dropdown-filter"]) {
		if (fieldConfig["allowable-data-type"].indexOf("array") !== -1) {
			if (fieldConfig["allowable-data-type"].length === 1) {
				result = result.filter(keyword => keyword.allowMultiple);
			} else {
				result = keywords.filter(keyword => {
					return (
						keyword.allowMultiple ||
						fieldConfig["allowable-data-type"].indexOf(keyword.dataType) !== -1
					);
				});
			}
		} else {
			result = result.filter(
				keyword =>
					fieldConfig["allowable-data-type"].indexOf(keyword.dataType) !== -1 ||
					keyword.dataType === "universal"
			);
		}
	}
	return result;
};

export default keywordFilterBlock;
